import { render, staticRenderFns } from "./costomPreviwBtn.vue?vue&type=template&id=45c1b2e1&scoped=true"
import script from "./costomPreviwBtn.vue?vue&type=script&lang=js"
export * from "./costomPreviwBtn.vue?vue&type=script&lang=js"
import style0 from "./costomPreviwBtn.vue?vue&type=style&index=0&id=45c1b2e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c1b2e1",
  null
  
)

export default component.exports